"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var YouTubeContent = function YouTubeContent(_ref) {
  var alt = _ref.alt,
      autoPlay = _ref.autoPlay,
      embedID = _ref.embedID,
      loop = _ref.loop,
      styleSet = _ref.styleSet;
  var search = new URLSearchParams({
    autoplay: autoPlay ? 1 : 0,
    loop: loop ? 1 : 0,
    modestbranding: 1
  }).toString();
  return (// TODO: We should encodeURI the URL
    _react.default.createElement("iframe", {
      "aria-label": alt,
      className: styleSet.youTubeContent,
      src: "https://youtube.com/embed/".concat(embedID, "?").concat(search)
    })
  );
};

YouTubeContent.defaultProps = {
  alt: '',
  autoPlay: false,
  loop: false
};
YouTubeContent.propTypes = {
  alt: _propTypes.default.string,
  autoPlay: _propTypes.default.bool,
  embedID: _propTypes.default.string.isRequired,
  loop: _propTypes.default.bool,
  styleSet: _propTypes.default.shape({
    youTubeContent: _propTypes.default.any.isRequired
  }).isRequired
};

var _default = (0, _connectToWebChat.default)(function (_ref2) {
  var styleSet = _ref2.styleSet;
  return {
    styleSet: styleSet
  };
})(YouTubeContent);

exports.default = _default;